/**
 * 特殊权限授权模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const special = {
    //得到授权数据集合
    list(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/special`, { params: params});
    },
    //得到授权数据集合
    info(params,userid) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/special/`+userid, { params: params});
    },
    //新增特殊授权数据
    add(params) {
      return axios.put(`${Vue.prototype.$base.API_PATH}/special/add`, params);
    },
    //删除指定人员的特殊授权
    delete(userid) {
      return axios.post(`${Vue.prototype.$base.API_PATH}/special/`+userid+`/delete`);
    },
    //修改指定人员的特殊授权
    update(params,userid) {
      return axios.post(`${Vue.prototype.$base.API_PATH}/special/`+userid+`/update`, params);
    },
}

export default special;



// WEBPACK FOOTER //
// ./src/api/special.js